import { Type } from "@angular/core";
import { ChartWidgetComponent as ChartWidgetComponent, IChartWidgetConfig as IChartWidgetConfig } from "../../chart/chart.component";
import { MachineInfoComponent as MachineInfoWidgetComponent, MachineInfoWidgetConfig as IMachineInfoWidgetConfig } from "../../machine-info/machine-info.component";
import { MachineInfoSettingsComponent } from "../../machine-info/machine-info-settings/machine-info-settings.component";
import { ChartSettingsComponent } from "../../chart/chart-settings/chart-settings.component";
import { ChartCanvaWidgetComponent as ChartCanvaWidgetComponent } from "../../chart-canva/chart-canva.component";
import { MachinesStateWidgetComponent } from "../../machines-state-widget/machines-state-widget.component";
import { IMachineViewWidgetConfig, MachineViewWidgetConponent } from "../../machine-view/machine-view.component";
import { MachineViewSettingsComponent } from "../../machine-view/machine-view-settings/machine-view-settings.component";
import { CorrectorsWidgetComponent } from "../../correctors-widget/correctors-widget.component";
import { CorrectorsSettingsComponent } from "../../correctors-widget/correctors-settings/correctors-settings.component";
import { AdjustPanelWidgetComponent, IAdjustPanelWidgetConfig } from "../../adjust-panel/adjust-panel.component";
import { AdjustPanelSettingsComponent } from "../../adjust-panel/adjust-panel-settings/adjust-panel-settings.component";

/**
 * V tomto subore sa nachadzaju definicie pre widgety, ktore sa pouzivaju v dashboardoch.
 * Su tu definovane zakladne typy pre widgety, ako aj zoznamy komponentov a ich nastaveni.
 */

// Definicie typov pre widgety
export type WidgetComponent = ChartWidgetComponent | MachineInfoWidgetComponent | ChartCanvaWidgetComponent | MachinesStateWidgetComponent | MachineViewWidgetConponent | CorrectorsWidgetComponent | AdjustPanelWidgetComponent;
export type WidgetSettingsComponent = MachineInfoSettingsComponent | ChartSettingsComponent | MachineViewSettingsComponent | CorrectorsSettingsComponent | AdjustPanelSettingsComponent;

/**
 * Base widget config
 *
 * @export
 * @interface IBaseWidgetConfig
 */
export interface IBaseWidgetConfig {
    title: string;
    subtitle?: string;
    machineName? : string;
}

/**
 * Widget types as enum.
 *
 * @export
 * @enum {string}
 */
export enum WidgetType {
    Chart = 'ChartWidget',
    MachineInfo = 'MachineInfoWidget',
    ChartCanva = 'ChartCanvaWidget',
    Empty = 'EmptyWidget',
    MachinesState = 'MachinesStateWidget',
    MachineView = 'MachineViewWidget',
    Correctors = 'CorrectorsWidget',
    AdjustPanel = 'AdjustPanelWidget'
}

/**
 * Interface of widget for list.
 *
 * @export
 * @interface IWidgetList
 */
export interface IWidgetList {
    type: WidgetType;
    name: string;
    icon: string;
    widgetComponent: Type<WidgetComponent> | null;
    settingsComponent: Type<WidgetSettingsComponent> | null;
    defaultOptions?: IChartWidgetConfig | IMachineInfoWidgetConfig | IBaseWidgetConfig | IMachineViewWidgetConfig | IAdjustPanelWidgetConfig;
    hasRefreshButton: boolean;
}

/**
 * Zoznam widgetov, ktore sa pouzivaju v dashboardoch.
 * Kazdy widget ma definovany typ, nazov, komponent, nastavenia a defaultne nastavenia.
 * !!Pri pridavani noveho widgetu je potrebne pridat jeho definiciu do tohto zoznamu.!!
 */
export const widgetComponentsList: IWidgetList[] = [
    {
        type: WidgetType.Empty,
        name: 'Empty',
        icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M41.1379 7V40M41.1379 73V40M41.1379 40H7M41.1379 40H73" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
        widgetComponent: null,
        settingsComponent: null,
        defaultOptions: {
          title:"Empty"
        },
        hasRefreshButton: false
    },
    // { // hide dx
    //     type: WidgetType.Chart,
    //     name: 'Chart',
    //     icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    //             <path d="M5 5V74.5M5 74.5H76M5 74.5L24 41.5L34 53.5L46 25L57.5 37.5L75 5" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
    //             </svg>`,
    //     widgetComponent: ChartWidgetComponent,
    //     settingsComponent: ChartSettingsComponent,
    //     hasRefreshButton: false
    // },
    {
        type: WidgetType.MachineInfo,
        name: 'Machine Info',
        icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.5 26.54C38.46 26.54 37.58 26.22 36.86 25.58C36.14 24.9 35.78 24.06 35.78 23.06C35.78 22.06 36.14 21.22 36.86 20.54C37.58 19.86 38.46 19.52 39.5 19.52C40.62 19.52 41.54 19.86 42.26 20.54C43.02 21.22 43.4 22.06 43.4 23.06C43.4 24.02 43.02 24.84 42.26 25.52C41.54 26.2 40.62 26.54 39.5 26.54ZM39.56 62.6C38.68 62.6 38 62.36 37.52 61.88C37.04 61.36 36.8 60.66 36.8 59.78V34.82C36.8 33.94 37.04 33.26 37.52 32.78C38 32.26 38.68 32 39.56 32C40.44 32 41.12 32.26 41.6 32.78C42.08 33.26 42.32 33.94 42.32 34.82V59.78C42.32 60.66 42.08 61.36 41.6 61.88C41.12 62.36 40.44 62.6 39.56 62.6Z" fill="white"/>
                <circle cx="40" cy="40" r="33" stroke="white" stroke-width="4"/>
                </svg>`,
        widgetComponent: MachineInfoWidgetComponent,
        settingsComponent: MachineInfoSettingsComponent,
        defaultOptions: {
            machineId: null,
            refreshInterval: 10000,
            title: 'Machine Info'
        },
        hasRefreshButton: false
    },
    {
        type: WidgetType.ChartCanva,
        name: 'Chart Canva',
        icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5V74.5M5 74.5H76M5 74.5L24 41.5L34 53.5L46 25L57.5 37.5L75 5" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
        widgetComponent: ChartCanvaWidgetComponent,
        settingsComponent: ChartSettingsComponent,
        defaultOptions: {
            series: '',
            argumentField: 'arg',
            valueField: 'val',
            bufferSize: 100,
            valueVisualRange: { min: 0, max: 100 },
            machineName: '',
            title: 'Chart',
            graphType: 'lineSeries',
            valueAxisAutoSacle: false,
            tickInterval: undefined
        },
        hasRefreshButton: false
    },
    // {
    //     type: WidgetType.MachinesState,
    //     name: 'Machines state',
    //     icon: '<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5 5V74.5M5 74.5H76M5 74.5L24 41.5L34 53.5L46 25L57.5 37.5L75 5" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    //     widgetComponent: MachinesStateWidgetComponent,
    //     settingsComponent: null,
    //     defaultOptions: {
    //         title: 'Machines States'
    //     },
    //     hasRefreshButton: true
    // },
    {
        type: WidgetType.Correctors,
        name: 'Correctors',
        icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17.5" cy="26" r="4.5" stroke="white" stroke-width="4"/><circle cx="39.5" cy="52" r="4.5" stroke="white" stroke-width="4"/><circle cx="62.5" cy="39" r="4.5" stroke="white" stroke-width="4"/><path d="M17.5 5V21M39.5 47V5M39.5 56.5V75M62.5 34V5M62.5 44V75M17.5 31V75" stroke="white" stroke-width="4" stroke-linecap="round"/></svg>`,
        widgetComponent: CorrectorsWidgetComponent,
        settingsComponent: CorrectorsSettingsComponent,
        defaultOptions: {
            title: 'Correctors',
            machineName: undefined
        },
        hasRefreshButton: false
    },
    {
        type: WidgetType.MachineView,
        name: 'Machines view',
        icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_124_2)">
                <path d="M17.74 62.6C14.46 62.6 11.4 62 8.56 60.8C5.72 59.56 3.36 57.8 1.48 55.52C1 54.92 0.76 54.3 0.76 53.66C0.76 52.86 1.14 52.2 1.9 51.68C2.42 51.36 2.9 51.2 3.34 51.2C4.22 51.2 4.98 51.62 5.62 52.46C6.98 54.18 8.72 55.52 10.84 56.48C12.96 57.44 15.26 57.92 17.74 57.92C21.22 57.92 23.94 57.26 25.9 55.94C27.86 54.62 28.84 52.76 28.84 50.36C28.84 45 26.16 42.32 20.8 42.32H14.14C13.22 42.32 12.5 42.12 11.98 41.72C11.5 41.32 11.26 40.76 11.26 40.04C11.26 38.48 12.22 37.7 14.14 37.7H20.8C22.92 37.7 24.62 37.1 25.9 35.9C27.18 34.7 27.82 33.1 27.82 31.1C27.82 28.86 26.96 27.14 25.24 25.94C23.52 24.7 21.06 24.08 17.86 24.08C13.26 24.08 9.6 25.64 6.88 28.76C6.24 29.52 5.52 29.9 4.72 29.9C4.16 29.9 3.64 29.72 3.16 29.36C2.44 28.88 2.08 28.22 2.08 27.38C2.08 26.7 2.34 26.1 2.86 25.58C4.74 23.58 6.96 22.06 9.52 21.02C12.12 19.94 14.9 19.4 17.86 19.4C21.06 19.4 23.82 19.88 26.14 20.84C28.5 21.8 30.3 23.18 31.54 24.98C32.82 26.74 33.46 28.78 33.46 31.1C33.46 32.9 32.94 34.54 31.9 36.02C30.9 37.5 29.4 38.76 27.4 39.8V39.92C29.8 40.96 31.58 42.34 32.74 44.06C33.9 45.74 34.48 47.84 34.48 50.36C34.48 52.88 33.8 55.06 32.44 56.9C31.08 58.74 29.14 60.16 26.62 61.16C24.1 62.12 21.14 62.6 17.74 62.6ZM49.9178 62C47.2778 62 45.2178 61.3 43.7378 59.9C42.2978 58.5 41.5778 56.56 41.5778 54.08V27.74C41.5778 25.34 42.2978 23.46 43.7378 22.1C45.1778 20.7 47.1778 20 49.7378 20H58.1378C62.4178 20 66.1378 20.86 69.2978 22.58C72.4978 24.3 74.9578 26.74 76.6778 29.9C78.3978 33.06 79.2578 36.78 79.2578 41.06C79.2578 45.34 78.3978 49.06 76.6778 52.22C74.9978 55.34 72.5578 57.76 69.3578 59.48C66.1978 61.16 62.4578 62 58.1378 62H49.9178ZM57.5378 57.44C62.7378 57.44 66.6978 56.04 69.4178 53.24C72.1778 50.44 73.5578 46.38 73.5578 41.06C73.5578 35.74 72.1778 31.66 69.4178 28.82C66.6578 25.98 62.6978 24.56 57.5378 24.56H50.2178C49.2978 24.56 48.5578 24.86 47.9978 25.46C47.4778 26.06 47.2178 26.86 47.2178 27.86V54.14C47.2178 55.14 47.4778 55.94 47.9978 56.54C48.5578 57.14 49.2978 57.44 50.2178 57.44H57.5378Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_124_2">
                <rect width="80" height="80" fill="white"/>
                </clipPath>
                </defs>
                </svg>`,
        widgetComponent: MachineViewWidgetConponent,
        settingsComponent: MachineViewSettingsComponent,
        defaultOptions: {
            title: 'Machine view',
            machineName: undefined,
        },
        hasRefreshButton: false
    },
    {
        type: WidgetType.AdjustPanel,
        name: 'Adjust Panel',
        icon: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="39.5" cy="52" r="4.5" stroke="white" stroke-width="4"/>
                <circle cx="62.5" cy="39" r="4.5" stroke="white" stroke-width="4"/>
                <path d="M39.5 47V5M39.5 56.5V75M62.5 34V5M62.5 44V75" stroke="white" stroke-width="4" stroke-linecap="round"/>
                <rect x="10" y="7" width="14" height="14" rx="4" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                <rect x="10" y="33" width="14" height="14" rx="4" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                <rect x="10" y="59" width="14" height="14" rx="4" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                </svg>`,
        widgetComponent: AdjustPanelWidgetComponent,
        settingsComponent: AdjustPanelSettingsComponent,
        defaultOptions: {
            title: 'Adjust Panel',
            machineName: undefined,
            sectionIndex: 0,
        },
        hasRefreshButton: false
    }


];

/**
 * Funkcia na ziskanie komponentu pre widget podla jeho typu.
 * @param type Typ widgetu
 * @returns Komponent widgetu
 */
export function getWidgetComponent(type: WidgetType): Type<WidgetComponent> | null {
    for(const widget of widgetComponentsList) {
        if (widget.type === type) {
            return widget.widgetComponent;
        }
    }

    return null;
}

/**
 * Funkcia na ziskanie komponentu pre nastavenia widgetu podla jeho typu.
 * @param type Typ widgetu
 * @returns Komponent nastaveni widgetu
 */
export function getSettingsComponent(type: WidgetType): Type<WidgetSettingsComponent> | null {
    for(const widget of widgetComponentsList) {
        if (widget.type === type) {
            return widget.settingsComponent;
        }
    }

    return null;
}
